import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4f695b46&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/client_view_mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f695b46')) {
      api.createRecord('4f695b46', component.options)
    } else {
      api.reload('4f695b46', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=4f695b46&", function () {
      api.rerender('4f695b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/404.vue"
export default component.exports